/**
 * Do not edit directly
 * Generated on Tue, 23 Jul 2024 13:51:28 GMT
 */

module.exports = {text : {emphasis:{
            name: "text.emphasis",
            hex: "#2E3A47",
            description: "Used for any text content and icons used with text that needs emphasizing"
          },body:{
            name: "text.body",
            hex: "#36485C",
            description: "Used for default text content and icons used with text"
          },subdued:{
            name: "text.subdued",
            hex: "#475A70",
            description: "Used for any text content and icons used with text that requires less prominence"
          },onBackground:{
            name: "text.onBackground",
            hex: "#FFFFFF",
            description: "For use on darker or colour profile backgrounds that require highly contrasted text"
          }},
system : {textLabelEmphasis:{
            name: "system.textLabelEmphasis",
            hex: "#2E3A47",
            description: "Used for any text content and icons used with text that needs emphasizing"
          },textBase:{
            name: "system.textBase",
            hex: "#475A70",
            description: "Used as the text or fill colour for interactive and static system components such as links, text, and icons"
          },textHover:{
            name: "system.textHover",
            hex: "#36485C",
            description: "Used as the hovered text or fill colour for interactive system components such as links and text buttons"
          },textActive:{
            name: "system.textActive",
            hex: "#2E3A47",
            description: "Used as the pressed text or fill colour for interactive system components such as links and text buttons"
          },backgroundBase:{
            name: "system.backgroundBase",
            hex: "#FFFFFF",
            description: "Used as the background for system components"
          },backgroundMuted:{
            name: "system.backgroundMuted",
            hex: "#F5F7FA",
            description: "Used as the muted background for system components"
          },backgroundMutedHover:{
            name: "system.backgroundMutedHover",
            hex: "#E6EDF5",
            description: "Used as the hovered muted background for system components"
          },backgroundMutedActive:{
            name: "system.backgroundMutedActive",
            hex: "#C8D3E0",
            description: "Used as the pressed muted background for system components"
          },backgroundBox:{
            name: "system.backgroundBox",
            hex: "#FCFEFF",
            description: "Used as a background colour for a system container like Box or Message"
          },borderBase:{
            name: "system.borderBase",
            hex: "#B8C6D6",
            description: "Used for the border colour for system components"
          },borderHover:{
            name: "system.borderHover",
            hex: "#596D84",
            description: "Used for the hovered border colour for system components"
          },borderActive:{
            name: "system.borderActive",
            hex: "#475A70",
            description: "Used for the pressed border colour for system components"
          },borderFocused:{
            name: "system.borderFocused",
            hex: "#3971A8",
            description: "Used for the focused border colour for system components"
          }},
surface : {level0:{
            name: "surface.level0",
            hex: "#FFFFFF",
            description: "Used for setting the lowest most level, mainly applied as a background color to the HTML body. Should always be underneath levels 1 and 2"
          },level1:{
            name: "surface.level1",
            hex: "#FFFFFF",
            description: "Used commonly with Boxes and containers that are directly on surface level 0. Also can be used as an alternative HTML body background color."
          },level2:{
            name: "surface.level2",
            hex: "#F5F7FA",
            description: "Used for elements that are contained within Boxes or other wrappers that are surface level 1."
          },interactiveBackground:{
            name: "surface.interactiveBackground",
            hex: "#FFFFFF",
            description: "Used for elements where the entire surface is interactable. For example Accordions, ActionBlock, and DropdownItems"
          },interactiveHover:{
            name: "surface.interactiveHover",
            hex: "#F5F7FA",
            description: "Hover state for elements where the entire surface is interactable. For example Accordions, ActionBlock, and DropdownItems"
          },interactiveActive:{
            name: "surface.interactiveActive",
            hex: "#E6EDF5",
            description: "Active/Pressed state for elements where the entire surface is interactable. For example Accordions, ActionBlock, and DropdownItems"
          },overlayDark:{
            name: "surface.overlayDark",
            hex: "#2E3A47",
            description: "Used for elements that are absolutely positioned to overlay content on the page. Is always a dark background regardless of theme. Ex: Things like Toasts and Tooltips"
          },overlayTheme:{
            name: "surface.overlayTheme",
            hex: "#FFFFFF",
            description: "Used for elements that are absolutely positioned to overlay content on the page. Matches the base color of the theme. Ex: Snackbar"
          },overlayBackdrop:{
            name: "surface.overlayBackdrop",
            hex: "#36485C",
            description: "Used to overlay & de-emphasize the page to draw focus to certain areas. Ex: Used with Modals, Drawers"
          },overlayModal:{
            name: "surface.overlayModal",
            hex: "#FFFFFF",
            
          },borderBase:{
            name: "surface.borderBase",
            hex: "#C8D3E0",
            
          },borderHover:{
            name: "surface.borderHover",
            hex: "#596D84",
            
          },borderActive:{
            name: "surface.borderActive",
            hex: "#475A70",
            
          }},
primary : {textBase:{
            name: "primary.textBase",
            hex: "#FFFFFF",
            description: "Used as the text or fill colour for interactive and static primary components such as links, text, and icons"
          },textHover:{
            name: "primary.textHover",
            hex: "#FFFFFF",
            description: "Used as the hovered text or fill colour for interactive primary components such as links and text buttons"
          },textActive:{
            name: "primary.textActive",
            hex: "#FFFFFF",
            description: "Used as the pressed text or fill colour for interactive primary components such as links and text buttons"
          },backgroundBase:{
            name: "primary.backgroundBase",
            hex: "#36485C",
            description: "Used as the background for primary components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "primary.backgroundHover",
            hex: "#2E3A47",
            description: "Used as the hovered background for primary components such as plain buttons"
          },backgroundActive:{
            name: "primary.backgroundActive",
            hex: "#212933",
            description: "Used as the hovered background for primary components such as plain buttons"
          },backgroundMuted:{
            name: "primary.backgroundMuted",
            hex: "#F5F7FA",
            description: "Used as the muted background for primary components such as pills and text buttons. Paired with primary.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "primary.backgroundMutedHover",
            hex: "#E6EDF5",
            description: "Used as the hovered muted background for primary components such as pills and text buttons. Paired with primary.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "primary.backgroundMutedActive",
            hex: "#C8D3E0",
            description: "Used as the pressed muted background for primary components such as pills and text buttons. Paired with primary.textBase for a subtler contrast"
          },backgroundBox:{
            name: "primary.backgroundBox",
            hex: "#FCFEFF",
            description: "Used as a very light background for primary components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "primary.borderBase",
            hex: "#C8D3E0",
            description: "Used for the border colour for primary components"
          },borderHover:{
            name: "primary.borderHover",
            hex: "#596D84",
            description: "Used for the hovered border colour for primary components"
          },borderActive:{
            name: "primary.borderActive",
            hex: "#2E3A47",
            description: "Used for the pressed border colour for primary components"
          }},
success : {textBase:{
            name: "success.textBase",
            hex: "#307553",
            description: "Used as the text or fill colour for successful intention versions of components such as message, pill, or box"
          },textHover:{
            name: "success.textHover",
            hex: "#275E43",
            description: "Used as the hovered text or fill colour for successful intention versions of components such as message, pill, or box"
          },textActive:{
            name: "success.textActive",
            hex: "#244C38",
            description: "Used as the pressed text or fill colour for successful intention versions of components such as message, pill, or box"
          },backgroundBase:{
            name: "success.backgroundBase",
            hex: "#307553",
            description: "Description to come."
          },backgroundHover:{
            name: "success.backgroundHover",
            hex: "#275E43",
            description: "Description to come."
          },backgroundActive:{
            name: "success.backgroundActive",
            hex: "#244C38",
            description: "Description to come."
          },backgroundMuted:{
            name: "success.backgroundMuted",
            hex: "#EBF2EF",
            description: "Used as the muted background for successful intention versions of components such as message, pill, or box. Paired with successful.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "success.backgroundMutedHover",
            hex: "#D1E0D9",
            description: "Used as the hovered muted background for successful intention versions of components such as message, pill, or box. Paired with successful.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "success.backgroundMutedActive",
            hex: "#B6CFC2",
            description: "Used as the pressed muted background for successful intention versions of components such as message, pill, or box. Paired with successful.textBase for a subtler contrast"
          },backgroundBox:{
            name: "success.backgroundBox",
            hex: "#FAFFFC",
            description: "Used as a very light background for successful intention versions of components such as message, pill, or box. Used for containers with content blocks"
          },borderBase:{
            name: "success.borderBase",
            hex: "#307553",
            description: "Used for the border colour for successful intention versions of components such as buttons and Message"
          },borderHover:{
            name: "success.borderHover",
            hex: "#275E43",
            description: "Used for the hovered border colour for successful components such as message"
          },borderActive:{
            name: "success.borderActive",
            hex: "#244C38",
            description: "Used for the pressed border colour for successful components such as message"
          }},
info : {textBase:{
            name: "info.textBase",
            hex: "#3971A8",
            description: "Used as the text or fill colour for interactive and static informational components such as links, text, and icons"
          },textHover:{
            name: "info.textHover",
            hex: "#21588F",
            description: "Used as the hovered colour for interactive informational components such as links and text buttons"
          },textActive:{
            name: "info.textActive",
            hex: "#194673",
            description: "Used as the pressed colour for interactive informational components such as links and text buttons"
          },backgroundBase:{
            name: "info.backgroundBase",
            hex: "#3971A8",
            description: "Used as the background for informational components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "info.backgroundHover",
            hex: "#21588F",
            description: "Used as the hovered background for informational components such as plain buttons"
          },backgroundActive:{
            name: "info.backgroundActive",
            hex: "#194673",
            description: "Used as the pressed background for informational components such as plain buttons"
          },backgroundMuted:{
            name: "info.backgroundMuted",
            hex: "#E6F1FC",
            description: "Used as the muted background for informational components such as pills and text buttons. Paired with info.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "info.backgroundMutedHover",
            hex: "#C0D8F0",
            description: "Used as the hovered muted background for informational components such as pills and text buttons. Paired with info.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "info.backgroundMutedActive",
            hex: "#88B1D9",
            description: "Used as the pressed muted background for informational components such as pills and text buttons. Paired with info.textBase for a subtler contrast"
          },backgroundBox:{
            name: "info.backgroundBox",
            hex: "#F5FAFF",
            description: "Used as a very light background for informational components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "info.borderBase",
            hex: "#3971A8",
            description: "Used for the border colour for informational components such as buttons and Message"
          },borderHover:{
            name: "info.borderHover",
            hex: "#21588F",
            description: "Used for the hovered border colour for informational components such as buttons"
          },borderActive:{
            name: "info.borderActive",
            hex: "#194673",
            description: "Used for the pressed border colour for informational components such as buttons"
          }},
warning : {textBase:{
            name: "warning.textBase",
            hex: "#B4631D",
            description: "Used as the text or fill colour for interactive and static warning components such as links, text, and icons"
          },textHover:{
            name: "warning.textHover",
            hex: "#8E4D14",
            description: "Used as the hovered text or fill colour for interactive and static warning components such as links and text buttons"
          },textActive:{
            name: "warning.textActive",
            hex: "#784213",
            description: "Used as the pressed text or fill colour for interactive and static warning components such as links and text buttons"
          },backgroundBase:{
            name: "warning.backgroundBase",
            hex: "#B4631D",
            description: "Used as the background for warning components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "warning.backgroundHover",
            hex: "#8E4D14",
            description: "Used as the hovered background for warning components such as plain buttons"
          },backgroundActive:{
            name: "warning.backgroundActive",
            hex: "#784213",
            description: "Used as the pressed background for warning components such as plain buttons"
          },backgroundMuted:{
            name: "warning.backgroundMuted",
            hex: "#FFF3E8",
            description: "Used as the muted background for warning components such as pills and text buttons. Paired with warning.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "warning.backgroundMutedHover",
            hex: "#F3D8C0",
            description: "Used as the hovered muted background for warning components such as pills and text buttons. Paired with warning.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "warning.backgroundMutedActive",
            hex: "#E7B88F",
            description: "Used as the pressed muted background for warning components such as pills and text buttons. Paired with warning.textBase for a subtler contrast"
          },backgroundBox:{
            name: "warning.backgroundBox",
            hex: "#FFFAF5",
            description: "Used as a very light background for warning components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "warning.borderBase",
            hex: "#B4631D",
            description: "Used for the border colour for warning components such as buttons and Message"
          },borderHover:{
            name: "warning.borderHover",
            hex: "#8E4D14",
            description: "Used for the hovered border colour for warning components"
          },borderActive:{
            name: "warning.borderActive",
            hex: "#784213",
            description: "Used for the pressed border colour for warning components such as buttons"
          }},
danger : {textBase:{
            name: "danger.textBase",
            hex: "#AF2645",
            description: "Used as the text or fill colour for interactive and static danger components such as links, text, and icons"
          },textHover:{
            name: "danger.textHover",
            hex: "#980B29",
            description: "Used as the hovered colour for interactive danger components such as links and text buttons"
          },textActive:{
            name: "danger.textActive",
            hex: "#800D25",
            description: "Used as the pressed colour for interactive danger components such as links and text buttons"
          },backgroundBase:{
            name: "danger.backgroundBase",
            hex: "#AF2645",
            description: "Used as the background for danger components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "danger.backgroundHover",
            hex: "#980B29",
            description: "Used as the hovered background for danger components such as plain buttons"
          },backgroundActive:{
            name: "danger.backgroundActive",
            hex: "#800D25",
            description: "Used as the pressed background for danger components such as plain buttons"
          },backgroundMuted:{
            name: "danger.backgroundMuted",
            hex: "#FEEEF2",
            description: "Used as the muted background for danger components such as pills and text buttons. Paired with danger.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "danger.backgroundMutedHover",
            hex: "#F0C4CD",
            description: "Used as the hovered muted background for danger components such as pills and text buttons. Paired with danger.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "danger.backgroundMutedActive",
            hex: "#E296A6",
            description: "Used as the pressed muted background for danger components such as pills and text buttons. Paired with danger.textBase for a subtler contrast"
          },backgroundBox:{
            name: "danger.backgroundBox",
            hex: "#FFF7F9",
            description: "Used as a very light background for warning components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "danger.borderBase",
            hex: "#AF2645",
            description: "Used for the border colour for danger components such as buttons and Message"
          },borderHover:{
            name: "danger.borderHover",
            hex: "#980B29",
            description: "Used for the hovered border colour for danger components such as buttons"
          },borderActive:{
            name: "danger.borderActive",
            hex: "#800D25",
            description: "Used for the pressed border colour for danger components such as buttons"
          }},
highlight : {textBase:{
            name: "highlight.textBase",
            hex: "#533E7D",
            description: "Used as the text or fill colour for interactive and static highlight components such as links, text, and icons"
          },textHover:{
            name: "highlight.textHover",
            hex: "#3B2566",
            description: "Used as the hovered text or fill colour for interactive and static highlight components such as links and text buttons"
          },textActive:{
            name: "highlight.textActive",
            hex: "#2A174F",
            description: "Used as the pressed text or fill colour for interactive and static highlight components such as links and text buttons"
          },backgroundBase:{
            name: "highlight.backgroundBase",
            hex: "#533E7D",
            description: "Used as the background for highlight components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "highlight.backgroundHover",
            hex: "#3B2566",
            description: "Used as the hovered background for highlight components such as plain buttons"
          },backgroundActive:{
            name: "highlight.backgroundActive",
            hex: "#2A174F",
            description: "Used as the pressed background for highlight components such as plain buttons"
          },backgroundMuted:{
            name: "highlight.backgroundMuted",
            hex: "#F2ECFE",
            description: "Used as the muted background for highlight components such as pills and text buttons. Paired with highlight.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "highlight.backgroundMutedHover",
            hex: "#D7CEE9",
            description: "Used as the hovered muted background for highlight components such as pills and text buttons. Paired with highlight.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "highlight.backgroundMutedActive",
            hex: "#B9ABD5",
            description: "Used as the pressed muted background for highlight components such as pills and text buttons. Paired with highlight.textBase for a subtler contrast"
          },backgroundBox:{
            name: "highlight.backgroundBox",
            hex: "#FCFAFF",
            description: "Used as a very light background for highlight components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "highlight.borderBase",
            hex: "#533E7D",
            description: "Used for the border colour for highlight components such as buttons and Message"
          },borderHover:{
            name: "highlight.borderHover",
            hex: "#3B2566",
            description: "Used for the hovered border colour for highlight components"
          },borderActive:{
            name: "highlight.borderActive",
            hex: "#2A174F",
            description: "Used for the pressed border colour for highlight components such as buttons and Message"
          }},
disabled : {text:{
            name: "disabled.text",
            hex: "#596D84",
            description: "For use in disabled content like text and icons"
          },background:{
            name: "disabled.background",
            hex: "#F5F7FA",
            description: "Used as the background colour for disabled components"
          },nakedBackground:{
            name: "disabled.nakedBackground",
            hex: "transparent",
            description: "Used for the background in disabled components with little to no styling"
          },border:{
            name: "disabled.border",
            hex: "#C8D3E0",
            description: "Used as the border for disabled components"
          },inputBackground:{
            name: "disabled.inputBackground",
            hex: "#E6EDF5",
            description: "For use in disabled inputs as the background colour"
          },inputLabelText:{
            name: "disabled.inputLabelText",
            hex: "#596D84",
            description: "Used as the label colour for disabled inputs"
          }},
input : {backgroundBase:{
            name: "input.backgroundBase",
            hex: "#F5F7FA",
            description: "Used as the default background colour for HTML inputs"
          },backgroundHover:{
            name: "input.backgroundHover",
            hex: "#E6EDF5",
            description: "Used as the hovered background colour for HTML inputs"
          },backgroundInformation:{
            name: "input.backgroundInformation",
            hex: "#FFFFFF",
            description: "Used as the default background colour for the text description below the input"
          },textBase:{
            name: "input.textBase",
            hex: "#475A70",
            description: "Used for the default filled text colour for HTML inputs"
          },textInformation:{
            name: "input.textInformation",
            hex: "#475A70",
            description: "Used as the text content colour for the text description below the input"
          },textInformationError:{
            name: "input.textInformationError",
            hex: "#AF2645",
            description: "Used as the text content colour for the text description below the input when there are errors"
          },textLabel:{
            name: "input.textLabel",
            hex: "#475A70",
            description: "Used as the default static label colour in HTML inputs which appears as a placeholder in the static state"
          },textFloatingLabel:{
            name: "input.textFloatingLabel",
            hex: "#3971A8",
            description: "Used as the floated label colour when the HTML input has focus"
          },textFloatingLabelError:{
            name: "input.textFloatingLabelError",
            hex: "#AF2645",
            description: "Used as the static and floated label colour when the input is in an error state"
          },textPlaceholder:{
            name: "input.textPlaceholder",
            hex: "#596D84",
            description: "Used as the default placeholder text colour for basic and search inputs"
          },textActive:{
            name: "input.textActive",
            hex: "#2E3A47",
            description: "Used as the label colour for labels that don't float when focused, like the select component"
          },borderBase:{
            name: "input.borderBase",
            hex: "#E6EDF5",
            description: "Used as the default border colour"
          },borderError:{
            name: "input.borderError",
            hex: "#AF2645",
            description: "Used for the border colour when the input is in an error state"
          },borderHover:{
            name: "input.borderHover",
            hex: "#C8D3E0",
            description: "Used as the hovered border colour"
          },borderEmphasized:{
            name: "input.borderEmphasized",
            hex: "#596D84",
            description: "Used as the default bottom border colour for floating label inputs or as the default border for inputs like checkbox"
          },borderEmphasizedHover:{
            name: "input.borderEmphasizedHover",
            hex: "#475A70",
            description: "Used as the hovered bottom border colour for floating label inputs or as the hovered border for inputs like checkbox"
          },borderActive:{
            name: "input.borderActive",
            hex: "#3971A8",
            description: "Used as the pressed bottom border colour for floating label inputs or as the engaged border for inputs like checkbox"
          }},
separator : {base:{
            name: "separator.base",
            hex: "#C8D3E0",
            description: "Used for the colour of the separator element"
          }},
light : {backgroundBase:{
            name: "light.backgroundBase",
            hex: "#FFFFFF",
            description: "For use as background colour in light profile components on contrasting surface backgrounds"
          },backgroundContrast:{
            name: "light.backgroundContrast",
            hex: "#475A70",
            description: "For use as a contrasting background colour in light profile components, to match shade of surface background"
          },backgroundHover:{
            name: "light.backgroundHover",
            hex: "#F5F7FA",
            description: "For use as background hover colour in light profile components on contrasting surface backgrounds"
          },backgroundActive:{
            name: "light.backgroundActive",
            hex: "#E6EDF5",
            description: "For use as background active colour in light profile components on contrasting surface backgrounds"
          },textBase:{
            name: "light.textBase",
            hex: "#2E3A47",
            description: "Used as the content colour (text, icons) for light profile components, to match shade of constrasting surface background"
          },linkMutedBase:{
            name: "light.linkMutedBase",
            hex: "#F5F7FA",
            description: "Used as link colour for light profile components on contrasting surface backgrounds"
          },linkMutedHover:{
            name: "light.linkMutedHover",
            hex: "#FFFFFF",
            description: "Used for link hover colour for light profile components on contrasting surface backgrounds"
          }},
shadow : {base:{
            name: "shadow.base",
            hex: "#36485C",
            description: "For use only with box shadow tokens"
          }},
accent : {forestTextBody:{
            name: "accent.forestTextBody",
            hex: "#275E43",
            
          },forestTextEmphasis:{
            name: "accent.forestTextEmphasis",
            hex: "#244C38",
            description: "Accent used for headings and icons of empahsis"
          },forestBackgroundMuted0:{
            name: "accent.forestBackgroundMuted0",
            hex: "#EBF2EF",
            
          },forestBackgroundMuted1:{
            name: "accent.forestBackgroundMuted1",
            hex: "#D1E0D9",
            
          },forestBackgroundMuted2:{
            name: "accent.forestBackgroundMuted2",
            hex: "#B6CFC2",
            
          },sandTextBody:{
            name: "accent.sandTextBody",
            hex: "#5E4D27",
            
          },sandTextEmphasis:{
            name: "accent.sandTextEmphasis",
            hex: "#3E3114",
            description: "Accent colour used for heading or icons of emphasis"
          },sandBackgroundMuted0:{
            name: "accent.sandBackgroundMuted0",
            hex: "#F6F1E5",
            
          },sandBackgroundMuted1:{
            name: "accent.sandBackgroundMuted1",
            hex: "#E4D9C2",
            
          },sandBackgroundMuted2:{
            name: "accent.sandBackgroundMuted2",
            hex: "#DACCAA",
            
          }},
inverted : {backgroundBase:{
            name: "inverted.backgroundBase",
            hex: "#2E3A47",
            
          },backgroundHover:{
            name: "inverted.backgroundHover",
            hex: "#36485C",
            
          },backgroundActive:{
            name: "inverted.backgroundActive",
            hex: "#475A70",
            
          },textEmphasis:{
            name: "inverted.textEmphasis",
            hex: "#FFFFFF",
            
          },textBody:{
            name: "inverted.textBody",
            hex: "#F5F7FA",
            
          }},
secondary : {borderBase:{
            name: "secondary.borderBase",
            hex: "#2E3A47",
            
          },borderHover:{
            name: "secondary.borderHover",
            hex: "#212933",
            
          },borderActive:{
            name: "secondary.borderActive",
            hex: "#212933",
            
          },backgroundBase:{
            name: "secondary.backgroundBase",
            hex: "#FFFFFF",
            
          },backgroundHover:{
            name: "secondary.backgroundHover",
            hex: "#F5F7FA",
            
          },backgroundActive:{
            name: "secondary.backgroundActive",
            hex: "#E6EDF5",
            
          },textBase:{
            name: "secondary.textBase",
            hex: "#2E3A47",
            
          },textHover:{
            name: "secondary.textHover",
            hex: "#2E3A47",
            
          },textActive:{
            name: "secondary.textActive",
            hex: "#2E3A47",
            
          }},
smart : {backgroundBase:{
            name: "smart.backgroundBase",
            hex: "linear-gradient(65deg, #7495B9 10.68%, #4D7199 38.02%, #2E5988 79.03%)",
            
          },backgroundHover:{
            name: "smart.backgroundHover",
            hex: "linear-gradient(65deg, #7495B9 10.68%, #4D7199 20.59%, #2E5988 32.55%)",
            
          },backgroundActive:{
            name: "smart.backgroundActive",
            hex: "linear-gradient(65deg, #4D7199 10.68%, #2E5988 20.59%, #264A6E 32.55%)",
            
          }},};